<template>
    <div class="com-no-agent">
        <img
            src="https://cdn.chime.me/image/fs/sitebuild/2021121/23/original_a64fb474-f79c-49fc-964e-5d6a91403aa9.jpeg"
            :alt="$t('md-team.noResults')"
        />
        <div class="text">{{ $t('md-team.noResultsPleaseTry') }}</div>
    </div>
</template>

<script>
export default {
    i18next: {
        ns: 'md-team'
    }
};
</script>

<style lang="scss">
@import '../../../theme/media.scss';
@import '../../../theme/mixin.scss';
.com-no-agent {
    display: flex;
    align-items: center;
    justify-self: center;
    flex-direction: column;
    @include adapter((padding-top, 50px, 30px));
    img {
        width: 216px;
        height: 235px;
    }
    @include media-600 {
        img {
            width: 170px;
            height: 185px;
        }
    }
    .text {
        font-family: var(--font-bold);
        @include adapter((font-size, 18px, 14px), (margin-top, 30px, 20px));
        color: var(--color-info);
    }
}
</style>
